
import EventBusConstants from '@/constants/EventBusConstants';
import PlayerEmitter from '@/event/PlayerEmitter';
import { inject } from 'vue';
import { Vue, Prop, Options } from 'vue-property-decorator';
import ToolbarItem from './ToolbarItem.vue';
import ToolManager from '@/controllers/tools/ToolManager';
@Options({
  components: { ToolbarItem },
})
export default class RegularToolbarItem extends Vue {
  @Prop({ default: '' }) readonly icon: string | undefined;
  @Prop({ default: '' }) readonly title: string | undefined;
  @Prop({ default: '' }) readonly identifier: string | undefined;

  private playerEmitter: PlayerEmitter | undefined = inject('playerEmitter');
  private toolManager: ToolManager | undefined = inject<ToolManager>('toolManager');
  private togglePnpTool(): void {
    if (this.identifier) {
      this.playerEmitter?.emit(EventBusConstants.PNP_ITEM_CLICKED, [['name', this.identifier]]);
      this.toolManager!.toggleTool(this.identifier);
    }
  }

  private displayClose(): boolean {
    if (this.identifier) {
      return this.toolManager!.toolIsEnabled(this.identifier);
    } else {
      return false;
    }
  }
}
